import React, { useState } from 'react';
import { Button as SemiButton, Form, Modal } from '@douyinfe/semi-ui';
import ColorPicker from '../../../ColorPicker';

export const ButtonStyleForm = ({ data = {}, onChange }) => {
    const [visible, setVisible] = useState(false);
    const defaultData = {
        text: '按钮文本',
        backgroundColor: '#2db7f5',
        textColor: '#fff',
        fontSize: 16,
        width: 200,
        height: 48,
        borderRadius: 24
    };

    const handleFormChange = (field, value) => {
        const newData = { ...defaultData, ...data, ...field };
        newData.textColor = data.textColor
        newData.backgroundColor = data.backgroundColor

        //console.log("fff", newData, field)
        onChange?.(newData);
    }

    const handleStyleChange = (field, value) => {
        const newData = { ...defaultData, ...data, [field]: value };
        //data = { ...newData }
        onChange?.(newData);
    };

    const renderForm = () => (
        <Form
            initValues={{
                text: data.text || defaultData.text,
                backgroundColor: data.backgroundColor || defaultData.backgroundColor,
                textColor: data.textColor || defaultData.textColor,
                fontSize: data.fontSize || defaultData.fontSize,
                width: data.width || defaultData.width,
                height: data.height || defaultData.height,
                borderRadius: data.borderRadius || defaultData.borderRadius
            }}
            onValueChange={handleFormChange}
        >
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '8px' }}>
                <Form.Input
                    field="text"
                    label="按钮文本"
                    style={{ width: '100%' }}
                />
                <Form.Slot label="背景颜色">
                    <ColorPicker
                        value={data.backgroundColor || defaultData.backgroundColor}
                        onChange={(value) => handleStyleChange('backgroundColor', value)}
                    />
                </Form.Slot>
                <Form.Slot label="文字颜色">
                    <ColorPicker
                        value={data.textColor || defaultData.textColor}
                        onChange={(value) => handleStyleChange('textColor', value)}
                    />
                </Form.Slot>
                <Form.InputNumber
                    field="fontSize"
                    label="字体大小"
                    style={{ width: '100%' }}
                    suffix="px"
                />
                <Form.InputNumber
                    field="width"
                    label="按钮宽度"
                    style={{ width: '100%' }}
                    suffix="px"
                />
                <Form.InputNumber
                    field="height"
                    label="按钮高度"
                    style={{ width: '100%' }}
                    suffix="px"
                />
                <Form.InputNumber
                    field="borderRadius"
                    label="圆角大小"
                    style={{ width: '100%' }}
                    suffix="px"
                />
            </div>
        </Form>
    );

    return (
        <div>
            <div
                onClick={() => setVisible(true)}
                style={{
                    cursor: 'pointer',
                    padding: '8px',
                    border: '1px dashed var(--semi-color-border)',
                    borderRadius: '4px',
                    display: 'inline-block'
                }}
            >
                <StyledButton data={data} />
            </div>
            <Modal
                title="按钮设置"
                visible={visible}
                onCancel={() => setVisible(false)}
                footer={null}
                width={500}
                centered
            >
                {renderForm()}
            </Modal>
        </div>
    );
};

const StyledButton = ({ data, onClick, style = {} }) => {
    const defaultData = {
        text: '按钮文本',
        backgroundColor: '#2db7f5',
        textColor: '#fff',
        fontSize: 16,
        width: 200,
        height: 48,
        borderRadius: 24
    };

    const buttonStyle = {
        color: data?.textColor || defaultData.textColor,
        backgroundColor: data?.backgroundColor || defaultData.backgroundColor,
        fontSize: `${data?.fontSize || defaultData.fontSize}px`,
        width: `${data?.width || defaultData.width}px`,
        height: `${data?.height || defaultData.height}px`,
        borderRadius: `${data?.borderRadius || defaultData.borderRadius}px`,
        ...style
    };

    return (
        <SemiButton
            theme="solid"
            style={buttonStyle}
            onClick={onClick}
        >
            {data?.text || defaultData.text}
        </SemiButton>
    );
};

export default StyledButton;